import React from "react";
import Container from "../Layout/Container";
import { connect } from "react-redux";
import {
  getBrands,
  createBrand,
  updateBrand
} from "../../redux/Actions/brandAction";
import ContentBlock from "../Layout/ContentBlock";
import TableColumnBrand from "./Items/TableColumnBrand";
import BrandEditModal from "./Items/BrandEditModal";
import FilterMenu from "../Layout/FilterMenu";
import TableFilterBox from "../common/TableFilterBox";
import ContentValidation from "../common/ContentValidation";
import InputText from "../orders/accepted_orders/InputFilter";
import Pagination from "../Dashboard/items/Pagination";

const initialFilterState = {
  title: "",
  asset: "",
};

class Brand extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bodyValue: "",
      page: 1,
      pageCount: 100,
      paramsFilter: "",
      filter: initialFilterState,
    };
    this.available_edit = props.auth.user_role.identifier !== "hosts";
  }
  
  componentDidMount() {
    this.reloadData(this.state.paramsFilter);
  }

  componentDidUpdate(_, prevState) {
    if (
      prevState.page !== this.state.page ||
      prevState.pageCount !== this.state.pageCount
    ) {
      this.reloadData(this.state.paramsFilter);
    }
  }

  reloadData = (paramsFilter) => {
    this.props.getBrands(this.state.page, this.state.pageCount, paramsFilter);
  };

  setPagination = (page) => {
    this.setState({
      page,
    });
  };

  setPageCount = (pageCount) => {
    this.setState({
      pageCount,
      page: 1,
    });
  };

  onAction = (action, index) => {
    this.setState({
      requiredId: index,
      action: action,
    });
  };

  delayOnFilter = () => {
    if (this.props.loading_brands) {
      return setTimeout(() => {
        return this.delayOnFilter();
      }, 1000);
    }
    this.onFilter();
  };

  onFilter = () => {
    if (this.props.loading_brands) {
      return this.delayOnFilter();
    }
    let filterParams = [];
    if (this.state.filter.title.length > 0){
      filterParams.push(`&q[title_i_cont_any]=${this.state.filter.title}`);
    }
    if (this.state.filter.asset.length > 0){
      if (this.state.filter.asset === "yes") {
        filterParams.push(`&q[asset_present]=1`);
      } else if (this.state.filter.asset === "no") {
        filterParams.push(`&q[asset_blank]=1`);
      }
    }
    this.setState(
      {
        paramsFilter: filterParams.join(""),
        page: 1,
      },
      () => this.reloadData(filterParams.join(""))
    );
  };

  filterChange = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleKeyDown = (e) => {
    if (e.key == "Enter") {
      this.onFilter();
    }
  };

  clearFilter = () => {
    this.setState(
      {
        filter: {
          title: "",
          asset: ""
        },
      },
      () => this.onFilter()
    );
  };

  typeChange = (e) => {
    this.setState(
      {
        filter: {
          ...this.state.filter,
          [e.name]: e.value,
        },
      },
      () => this.onFilter()
    );
  };

  render() {
    const requiredItem = this.state.requiredId;
    let modalData = this.props.brands[requiredItem]
      ? this.props.brands[requiredItem]
      : [];
    return (
      <Container
        location={{
          locationName: "Prekių ženklai",
          locationUrl: this.props.match.url,
        }}
      >
        <ContentBlock>
          <FilterMenu
            length={`${this.props.totals || 0} / ${
              this.props.brands.length || 0
            }`}
            onChangeCountPage={this.setPageCount}
            countPage={this.state.pageCount}
            text="prekės ženklų"
            text2="Prekės ženklų"
          />
        </ContentBlock>
        <ContentBlock>
          <TableFilterBox 
          filter={false} 
          onFilter={this.onFilter}
          clearFilter={this.clearFilter}
          >
          <div className="px-1">
                      <InputText
                        width={"0.75rem"}
                        number="1"
                        name="title"
                        placeholder="Ženklas"
                        onKeyDown={this.handleKeyDown}
                        value={this.state.filter.title}
                        onChange={(e) => this.filterChange(e)}
                      />
          </div>{" "}
                <div className="px-1">
                  <div className="form-group">
                    <div>
                      <label className={"editLabelForm"}>Įkeltas logotipas</label>
                    </div>
                    <div className="d-flex">
                      <button className={"btn btn-custom-filter small " + (this.state.filter.asset === "" ? "active":"") }
                        onClick={() => this.typeChange({name:"asset", value:""})}
                      >
                        Visi
                      </button>
                      <button className={"btn btn-custom-filter small " + (this.state.filter.asset === "yes" ? "active":"") }
                        onClick={() => this.typeChange({name:"asset", value:"yes"})}
                      >
                        Taip
                      </button>
                      <button className={"btn btn-custom-filter small " +  (this.state.filter.asset === "no" ? "active":"") }
                        onClick={() => this.typeChange({name:"asset", value: 'no'})}
                        >
                        Ne
                      </button>
                    </div>
                  </div>
                </div>
          </TableFilterBox>
          <div>
            <ContentValidation
              loader={this.props.loading}
              array={this.props.brands}
              alertId_s="brandsAlert-s"
              alertId_e="brandsAlert-e"
            >
              <div className="table-responsive" style={{ overflow: "hidden" }}>
                <table className="table mt-3">
                  <thead>
                    <tr className="text-muted">
                      <th className="text-black">ID</th>
                      <th className="text-black">Ženklas</th>
                      <th className="text-black">Logotipas</th>
                      <th className="text-black"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.brands &&
                      this.props.brands.map((item, index) => {
                        return (
                          <TableColumnBrand
                            key={index}
                            index={index}
                            item={item}
                            onEdit={this.onAction}
                          />
                        );
                      })}
                  </tbody>
                </table>
                <Pagination
                  setPagination={this.setPagination}
                  page={this.state.page}
                  totals={this.props.totals}
                  pageCount={this.state.pageCount}
                />
              </div>
            </ContentValidation>
          </div>
        </ContentBlock>
        <BrandEditModal
          action={this.state.action}
          createBrand={this.props.createBrand}
          updateBrand={this.props.updateBrand}
          objectData={modalData}
          clearErrors={this.props.clearErrors}
          errors={this.props.errors}
        />
      </Container>
    );
  }
}
const mapStateToProps = (state) => ({
  brands: state.brand.brands,
  totals: state.brand.totals,
  loading: state.brand.loading_brands,
  errors: state.errors,
  auth: state.auth.user,
});

export default connect(mapStateToProps, {
  getBrands,
  createBrand,
  updateBrand
})(Brand);
